import * as i0 from '@angular/core';
import { Input, HostBinding, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
class StlrSpinnerComponent {
  constructor() {
    this.hostClass = true;
  }
  /**
   * For use on dark backgrounds
   */
  get isLight() {
    return this.color === 'light';
  }
  get color() {
    return this._color;
  }
  set color(value) {
    if (value === 'unset') {
      value = undefined;
    }
    this._color = value;
  }
  /**
   * To double the size
   */
  get isLarge() {
    return this.size === 'lrg';
  }
  get size() {
    return this._size;
  }
  set size(value) {
    if (value === 'unset') {
      value = undefined;
    }
    this._size = value;
  }
  static {
    this.ɵfac = function StlrSpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrSpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrSpinnerComponent,
      selectors: [["stlr-spinner"]],
      hostVars: 6,
      hostBindings: function StlrSpinnerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("stlr-spinner", ctx.hostClass)("light", ctx.isLight)("lrg", ctx.isLarge);
        }
      },
      inputs: {
        color: "color",
        size: "size"
      },
      standalone: false,
      decls: 0,
      vars: 0,
      template: function StlrSpinnerComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{--spinner__size: var(--space--16);--spinner__size--large: var(--space--24);--spinner__bg: rgba(0, 0, 0, .3);--spinner__border: black;--spinner__bg--white: rgba(255, 255, 255, .3);--spinner__border--white: white;display:inline-flex;position:relative;width:var(--spinner__size);height:var(--spinner__size)}[_nghost-%COMP%]:before{content:\"\";box-sizing:border-box;position:absolute;border-radius:50%;border:2px solid;animation:_ngcontent-%COMP%_spin .6s linear infinite;width:var(--spinner__size);height:var(--spinner__size)}[_nghost-%COMP%]:not(.light):before{border-color:var(--spinner__border) var(--spinner__bg) var(--spinner__bg)}.light[_nghost-%COMP%]:before{border-color:var(--spinner__border--white) var(--spinner__bg--white) var(--spinner__bg--white)}.lrg[_nghost-%COMP%]{width:var(--spinner__size--large);height:var(--spinner__size--large)}.lrg[_nghost-%COMP%]:before{width:var(--spinner__size--large);height:var(--spinner__size--large)}@keyframes _ngcontent-%COMP%_spin{to{transform:rotate(360deg)}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrSpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-spinner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "",
      styles: [":host{--spinner__size: var(--space--16);--spinner__size--large: var(--space--24);--spinner__bg: rgba(0, 0, 0, .3);--spinner__border: black;--spinner__bg--white: rgba(255, 255, 255, .3);--spinner__border--white: white;display:inline-flex;position:relative;width:var(--spinner__size);height:var(--spinner__size)}:host:before{content:\"\";box-sizing:border-box;position:absolute;border-radius:50%;border:2px solid;animation:spin .6s linear infinite;width:var(--spinner__size);height:var(--spinner__size)}:host:not(.light):before{border-color:var(--spinner__border) var(--spinner__bg) var(--spinner__bg)}:host.light:before{border-color:var(--spinner__border--white) var(--spinner__bg--white) var(--spinner__bg--white)}:host.lrg{width:var(--spinner__size--large);height:var(--spinner__size--large)}:host.lrg:before{width:var(--spinner__size--large);height:var(--spinner__size--large)}@keyframes spin{to{transform:rotate(360deg)}}\n"]
    }]
  }], null, {
    hostClass: [{
      type: HostBinding,
      args: ['class.stlr-spinner']
    }],
    isLight: [{
      type: HostBinding,
      args: ['class.light']
    }],
    color: [{
      type: Input
    }],
    isLarge: [{
      type: HostBinding,
      args: ['class.lrg']
    }],
    size: [{
      type: Input
    }]
  });
})();
class StlrSpinnerModule {
  static {
    this.ɵfac = function StlrSpinnerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrSpinnerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StlrSpinnerModule,
      declarations: [StlrSpinnerComponent],
      imports: [CommonModule],
      exports: [StlrSpinnerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrSpinnerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [StlrSpinnerComponent],
      exports: [StlrSpinnerComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { StlrSpinnerComponent, StlrSpinnerModule };
